import type { ConfigProviderProps } from "antd/lib/config-provider";
import { buildTheme, ThemeMode } from "./theme";

/** Component size follows the OSI guidelines (44px targets, 48px forms). */
export const buildConfig = (mode: ThemeMode): ConfigProviderProps => ({
  componentSize: "middle",
  theme: buildTheme(mode),
});

/** Back-compat export for anything still importing `config` directly. */
export const config: ConfigProviderProps = buildConfig("light");
